import { Model } from '@vuex-orm/core';

export class InvitationUserAuth extends Model {
    static entity = 'userAuth';

    static primaryKey = 'id';

    static fields() {
        return {
            id: this.attr(''),
            password: this.string(''),
            receivedOtp: this.boolean(false),
            otp: this.string(''),
            otpMobile: this.attr(null),
            modelId: this.attr(null),
            modelType: this.attr(null),
            requestTimestamp: this.number(0)
        };
    }
}
